import { withRoot } from './withRoot'
import { withPrefetchApi } from './withPrefetchApi'
import { withHtmlTag } from '../../withHtmlTag'

export function wrapPage(pageConfig, Component) {
  const middleWares = [
    withPrefetchApi,
    (_pageConfig) => withHtmlTag({ className: _pageConfig.className }),
    withRoot, // 必须在最末
  ]

  let TargetComponent = Component

  for (const m of middleWares.reverse()) {
    // 生效顺序与包装顺序相反
    TargetComponent = m(pageConfig)(TargetComponent)
  }
  return TargetComponent
}
